import { logo } from './images';

export default { Icon: logo, auto: true };
